export default "__VITE_ASSET__BBzEC5N___"